import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Helpful diagnostics: if these are missing, the app will behave like it's "offline"
// (auth appears signed-out, queries return errors). Keep this as a console error
// rather than throwing to avoid white-screening in production builds.
if (!supabaseUrl || !supabaseAnonKey) {
	// eslint-disable-next-line no-console
	console.error(
		"Missing Supabase env vars. Expected REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY."
	);
}

const fetchWithTimeout = async (input, init = {}) => {
	// Don't override an existing signal; respect callers that provide one.
	if (init.signal || typeof AbortController === "undefined") {
		return fetch(input, init);
	}

	const controller = new AbortController();
	const timeoutMs = 15000;
	const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

	try {
		return await fetch(input, { ...init, signal: controller.signal });
	} finally {
		clearTimeout(timeoutId);
	}
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	global: {
		fetch: fetchWithTimeout,
	},
});

// Ensure app starts signed out: if any session is persisted in storage, sign it out.
// This guarantees a fresh signed-out state on every app boot.
// (async () => {
// 	try {
// 		const { data } = await supabase.auth.getSession();
// 		const currentSession = data?.session ?? null;
// 		if (currentSession) {
// 			await supabase.auth.signOut();
// 		}
// 	} catch (err) {
// 		// Non-fatal; log for diagnostics.
// 		// eslint-disable-next-line no-console
// 		console.warn("Could not clear Supabase session on startup:", err);
// 	}
// })();
